export default __webpack_public_path__ + "static/media/radio.e545a2f7.png";